import axios from "axios";
class OemApiService {
    constructor() {
        // private methods
        this.handleError = (errorParam) => {
            console.log(errorParam);
        };
        this.handleSuccess = (responseParam) => {
            return responseParam.data;
        };
        //empty
    }
    // public methods
    async get(uriParam, baseURL = "") {
        return await this.getWithData(uriParam, { baseURL: baseURL });
    }
    async getWithData(uriParam, dataParam) {
        return await axios
            .get(uriParam, dataParam)
            .then(this.handleSuccess)
            .catch(this.handleError);
    }
    async post(uriParam) {
        return await axios.post(uriParam).then().catch();
    }
    async delete(uriParam) {
        return await axios.delete(uriParam).then().catch();
    }
}
export default new OemApiService();
